import { genId } from '@/utils/id'
import { seedMembers } from '@/mock/seed'

const AVATAR_COLORS = ['#ff8f6b', '#5b8def', '#3dbd8c', '#b17ee0', '#e0567e', '#e0b354']
const MOCK_JOIN_NAMES = ['Mia', 'Leo', 'Sana', 'Chris', 'Ivy', 'Marco']

function pickColor (existing) {
  return AVATAR_COLORS[existing.length % AVATAR_COLORS.length]
}

export default {
  namespaced: true,
  state: {
    list: seedMembers,
    inviteLinks: {} // tripId -> { token, createdAt, requiresApproval }
  },
  getters: {
    byTrip: state => tripId => state.list.filter(m => m.tripId === tripId && m.status === 'active'),
    allByTrip: state => tripId => state.list.filter(m => m.tripId === tripId),
    byId: state => id => state.list.find(m => m.id === id),
    inviteLink: state => tripId => state.inviteLinks[tripId] || null
  },
  mutations: {
    ADD_MEMBER (state, member) {
      state.list.push(member)
    },
    UPDATE_MEMBER (state, { id, patch }) {
      const m = state.list.find(x => x.id === id)
      if (m) Object.assign(m, patch)
    },
    SET_INVITE_LINK (state, { tripId, link }) {
      state.inviteLinks = { ...state.inviteLinks, [tripId]: link }
    }
  },
  actions: {
    ensureCreatorMember ({ commit, state }, { tripId, memberId, name }) {
      if (state.list.find(m => m.id === memberId)) return
      commit('ADD_MEMBER', {
        id: memberId, tripId, name: name || '我', color: pickColor(state.list),
        role: 'owner', isPlaceholder: false, status: 'active'
      })
    },
    addPlaceholder ({ commit, state }, { tripId, name }) {
      const id = genId()
      commit('ADD_MEMBER', {
        id, tripId, name, color: pickColor(state.list),
        role: 'member', isPlaceholder: true, status: 'active'
      })
      return id
    },
    generateInviteLink ({ commit }, { tripId, requiresApproval }) {
      const token = genId().slice(0, 8)
      const link = { token, createdAt: new Date().toISOString(), requiresApproval: !!requiresApproval, revoked: false }
      commit('SET_INVITE_LINK', { tripId, link })
      return `${window.location.origin}/join/${tripId}/${token}`
    },
    revokeInviteLink ({ commit, state }, tripId) {
      const link = state.inviteLinks[tripId]
      if (link) commit('SET_INVITE_LINK', { tripId, link: { ...link, revoked: true } })
    },
    // 模擬「有人透過邀請連結加入」，因為 demo 沒有第二個瀏覽器/帳號可以真的示範加入流程。
    simulateMemberJoin ({ commit, state }, tripId) {
      const used = state.list.filter(m => m.tripId === tripId).map(m => m.name)
      const name = MOCK_JOIN_NAMES.find(n => !used.includes(n)) || `旅伴 ${state.list.length + 1}`
      const id = genId()
      commit('ADD_MEMBER', {
        id, tripId, name, color: pickColor(state.list),
        role: 'member', isPlaceholder: false, status: 'active'
      })
      return { id, name }
    },
    claimPlaceholder ({ commit }, { memberId, newName }) {
      commit('UPDATE_MEMBER', { id: memberId, patch: { isPlaceholder: false, name: newName || undefined } })
    },
    leaveOrRemove ({ commit }, memberId) {
      commit('UPDATE_MEMBER', { id: memberId, patch: { status: 'left' } })
    }
  }
}
